import { h, render, Component } from 'preact';
import './map-tools-layers.scss';

export class LayersTools extends Component {
    constructor() {
        super();
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.openLayerTool(false);
        }
    }

    setMarkersVisibility = () => {
        let markersVisibility = this.props.markersService.setMarkersVisibility();
        window.localStorage.setItem('markersVisibility', markersVisibility);
        this.forceUpdate();
    }

    setGeozonesVisibility = () => {
        let geozonesVisibility = this.props.geofenceService.setGeozonesVisibility();
        window.localStorage.setItem('geozonesVisibility', geozonesVisibility);
        this.forceUpdate();
    }

    toggleGeofenceTooltipVisibility = () => {
        let geofenceTooltipVisibility = this.props.map.toggleGeofenceTooltipVisibility();
        window.localStorage.setItem('geofenceTooltipVisibility', geofenceTooltipVisibility);
        this.forceUpdate();
    }

    toggleObjectsNamesVisibility = () => {
        const objectsNamesVsibility = this.props.map.toggleObjectsNamesVisibility();
        window.localStorage.setItem('showObjectsNamesOnMap', objectsNamesVsibility);
        this.forceUpdate();
    }

    toggleRosreestrOverlayVisibility = () => {
        let rosreestrOverlayVisibility = this.props.map.toggleRosreestrOverlayVisibility();
        window.localStorage.setItem('rosreestrOverlayVisibility', rosreestrOverlayVisibility);
        this.forceUpdate();
    }

    changeLayer = baseLayer => {
        this.props.changeLayer(baseLayer);
        window.localStorage.setItem('mapBaseLayer', baseLayer.name);
        this.forceUpdate();
    }

    render(props, state) {
        this.openLayerTool = props.openLayerTool;
        return (
            <div ref={this.setWrapperRef} class="map-toolbar-layers-menu">
                { !this.props.map.isReport &&
                    <div class="map-toolbar-layers-menu__item">
                        <div class="fm-checkbox" onClick={this.setMarkersVisibility}>
                            <i class={this.props.markersService.isMarkersVisible ? "fm-checkbox__checkbox fm-checkbox__checkbox--checked" : "fm-checkbox__checkbox"}></i>
                            <span class="fm-checkbox__label">{messages['Objects']}</span>
                        </div>
                    </div>
                }
                { !this.props.map.isReport &&
                    <div class="map-toolbar-layers-menu__item" onClick={this.toggleObjectsNamesVisibility}>
                        <div class=" fm-checkbox">
                            <i class={this.props.map.options.showObjectsNames ? "fm-checkbox__checkbox fm-checkbox__checkbox--checked" : "fm-checkbox__checkbox"}></i>
                            <span class="fm-checkbox__label">{messages['ObjectsNames']}</span>
                        </div>
                    </div>
                }
                { !this.props.map.isReport &&
                    <div class="map-toolbar-layers-menu__item" onClick={this.setGeozonesVisibility}>
                        <div class=" fm-checkbox">
                            <i class={this.props.geofenceService.isGeozonesVisible ? "fm-checkbox__checkbox fm-checkbox__checkbox--checked" : "fm-checkbox__checkbox"}></i>
                            <span class="fm-checkbox__label">{messages['Geozones']}</span>
                        </div>
                    </div>
                }
                { !this.props.map.isReport &&
                    <div class="map-toolbar-layers-menu__item" onClick={this.toggleGeofenceTooltipVisibility}>
                        <div class=" fm-checkbox">
                            <i class={this.props.map.options.geofenceTooltip.isAlwaysVisible ? "fm-checkbox__checkbox fm-checkbox__checkbox--checked" : "fm-checkbox__checkbox"}></i>
                            <span class="fm-checkbox__label">{messages['GeofencesLabels']}</span>
                        </div>
                    </div>
                }
                {!this.props.map.isReport &&
                    <div class="map-toolbar-layers-menu__item" onClick={this.toggleRosreestrOverlayVisibility}>
                        <div class=" fm-checkbox">
                            <i class={this.props.map.options.rosreestrOverlay.isVisible ? "fm-checkbox__checkbox fm-checkbox__checkbox--checked" : "fm-checkbox__checkbox"}></i>
                            <span class="fm-checkbox__label">{'Rosreestr'}</span>
                        </div>
                    </div>
                }
                { !this.props.map.isReport &&
                    <div class="map-toolbar-layers-menu__separator">
                    </div>
                }
                {
                    this.props.map.baseLayers.map(baseLayer =>
                        <div class="map-toolbar-layers-menu__item">
                            <div class="fm-radio map-toolbar-layers-menu__fm-radio" onClick={e => this.changeLayer(baseLayer)}>
                                <i class={baseLayer == this.props.map.selectedLayer ? "fm-radio__radio fm-radio__radio--checked" : "fm-radio__radio"}></i>
                                <span class="fm-radio__label">{baseLayer.name}</span>
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
}
